const styles: React.CSSProperties = {
    width: "inital",
    border: 0,
    borderRadius: 0,
}

export default styles